// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const honchkrow: PokeData = {
  "id": 430,
  "name": "honchkrow",
  "height": 9,
  "weight": 273,
  "base_experience": 177,
  "types": [
    PokeType.DARK,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "wing-attack",
    "peck",
    "night-shade",
    "haze",
    "swagger",
    "mean-look",
    "pursuit",
    "torment",
    "taunt",
    "astonish",
    "air-cutter",
    "aerial-ace",
    "roost",
    "tailwind",
    "assurance",
    "sucker-punch",
    "dark-pulse",
    "night-slash",
    "air-slash",
    "brave-bird",
    "nasty-plot",
    "foul-play",
    "quash",
    "snarl",
    "comeuppance"
  ],
  "moves": [
    "gust",
    "peck",
    "night-shade",
    "pursuit",
    "aerial-ace",
    "roost",
    "tailwind",
    "dark-pulse",
    "night-slash",
    "air-slash",
    "brave-bird",
    "quash",
    "snarl"
  ],
  "evolution_chain": {
    "id": 97,
    "item": null,
    "species": [
      {
        "name": "murkrow",
        "order": 227,
        "types": [
          PokeType.DARK,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "honchkrow",
        "order": 228,
        "types": [
          PokeType.DARK,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 198,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "dusk-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 112,
    "speed": 104,
    "ability_power": 184
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
